const config={
  sale: {
    api:{
      travelInfo:'/data/travel-info',
      travelList:'/data/travel-list',
      travelSearch:'/data/travel-search'
    },
    map:{
      mapStyle:{
        default: {
          fill: "#988681",
          stroke: "#CCCCCC",
          strokeWidth: 0.75,
          outline: "none",
        },
        hover: {
          fill: "#C8B6B1",
          stroke: "#607D8B",
          strokeWidth: 0.75,
          outline: "none",
        },
        pressed: {
          fill: "#FF5722",
          stroke: "#607D8B",
          strokeWidth: 0.75,
          outline: "none",
        },
      },
      circleStyle:{
        fill: "#FFFFFF",
        stroke: "#F1B000",
        strokeWidth: 3,
        opacity: 0.9,
      }
    }
  },
};

export default config;



// WEBPACK FOOTER //
// ./src/pages/sale/config/config.js